const MOBILE_MEDIA_QUERY = '(max-width: 767px), (max-height: 767px) and (pointer: coarse)';

export default function initMobileMenu() {
  const toggle = document.querySelector('[data-nav-menu-toggle]');
  const overlay = document.querySelector('[data-nav-menu-overlay]');

  if (!toggle || !overlay) return;

  const mobileQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
  const setOpen = (isOpen) => {
    overlay.dataset.open = String(isOpen);
    overlay.setAttribute('aria-hidden', String(!isOpen));
    toggle.setAttribute('aria-expanded', String(isOpen));
    toggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    document.documentElement.classList.toggle('has-mobile-menu-open', isOpen);
  };

  toggle.addEventListener('click', () => setOpen(overlay.dataset.open !== 'true'));
  overlay.querySelectorAll('[data-nav-menu-link]').forEach((link) => link.addEventListener('click', () => setOpen(false)));
  mobileQuery.addEventListener('change', (event) => {
    if (!event.matches) setOpen(false);
  });
}